import { Box, Spinner, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
}

export const LoadingCollapsableCard = ({ title }: Props) => {
  return (
    <Box
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Box
        padding="s16"
        paddingLeft="s24"
        paddingRight="s24"
        flexDirection="row"
        gap="s12"
        justifyContent="spaceBetween"
      >
        <Box flexDirection="row" gap="s12">
          <Text.Normal weight="medium" color="grey1000">
            {title}
          </Text.Normal>

          <Spinner size="s24" />
        </Box>

        <TogglerCheckbox value={false} onChange={() => {}} disabled />
      </Box>
    </Box>
  )
}
